<template>
    <div class="pageDiv">
        <v-card class="main-card" v-if="tournament===null">
            <v-card-title>
                <span class="page-title">Match Play Results</span>
            </v-card-title>
            <v-card-text v-if="registerTournaments.length > 1">
                <v-card-text v-if="registerTournaments !== null && registerTournaments.length > 1">
                    <v-card-title>
                        Select course to show groupings:
                    </v-card-title>

                    <v-card-text>
                        <div v-for="tn in registerTournaments" :key="tn.tournament.tournamentId" style="padding:5px 10px; width:100%;text-align:left;">
                            <div class="select-btn" @click="selectTournament(tn)">
                              <span style="display:inline-block;padding-top:7px;;text-align:left;margin-right:20px">
                                {{printDateTime(tn.tournament.scheduleDate)}}
                              </span>
                                <span style="display:inline-block;padding-top:7px;text-align:left;">
                                {{tn.course!==null?tn.course.name:''}}
                              </span>
                                <span> ({{tn.tournament.formatType}}) </span>
                            </div>
                        </div>
                    </v-card-text>
                </v-card-text>
            </v-card-text>

            <v-card-text v-if="registerTournaments.length===0">
                <span class="label14">
                    Group pairings are not available.
                </span>
            </v-card-text>
        </v-card>

        <v-card class="main-card" v-if="tournament!==null">
            <v-card-title>
                <span class="page-title"> Group Pairings: ({{numberOfPlayers}} players)</span>
                <span class="label18">{{course.name}}</span>
            </v-card-title>

            <v-card-text class="groupPairingCard">
                <div class="group-card" v-for="(group, index) in groups" :key="group">
                    <v-simple-table class="simple-table">

                        <tr>
                            <th width="80%">
                                Group
                                <span v-if="group.teeBox==='null' || group.teeBox==='' || group.teeBox==='NULL'"> {{index+1}}: </span>
                                <span v-if="group.teeBox!=='null' && group.teeBox!=='' && group.teeBox!=='null' && group.teeBox!=='NULL'">
                                    Hole: {{group.teeBox}}
                                </span>
                                <a class="scoreCardLabel" v-if="tournament.formatType === 'FUN'" @click="scoreCard(group.groupId)">Score Card</a>
                            </th>
                            <th>Score</th>
                            <th>Thru</th>
                        </tr>
                        <tr>
                            <td>
                                <span v-for="ap in group.aPlayers" :key="ap">
                                    {{getName(ap)}}<br>
                                </span>
                            </td>
                            <td>{{group.aPlayers[0].matchScore}}</td>
                            <td>{{group.aPlayers[0].thruHoles===18?"F":group.aPlayers[0].thruHoles}}</td>
                        </tr>
                        <tr>
                            <td>
                                <span v-for="bp in group.bPlayers" :key="bp">
                                    {{getName(bp)}}<br>
                                </span>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';

  export default {
    name: "login",
    data: () => ({
      players: {},
      tournament: null,
      course: null,
      groups: null,
      numberOfPlayers: 0,
      registerTournaments: []
    }),
    mounted: function() {
     var _this = this;

      _this.tournament = null;
      _this.course == null;

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id')
      if (id !== null && id !== '') {
        _this.$CommandSvc.get(_this, '/public/tournament-course/' + id, function(data) {
          if (data !== null) {
            _this.tournament = data.tournament;
            _this.course = data.course;
            _this.loadPlayers(_this.tournament);
          }
        });
      } else {
        _this.$CommandSvc.get(_this, '/public/tournaments/status/PAIRINGS', function(data) {
          _this.registerTournaments = data;
          if (_this.registerTournaments !== null && _this.registerTournaments.length === 1) {
            _this.course = _this.registerTournaments[0].course;
            _this.tournament = _this.registerTournaments[0].tournament;
            _this.loadPlayers(_this.tournament);
          }
        });
      }
    },
    methods: {
      printDateTime(date) {
        return moment(date).format('MM/DD hh:mm A');
      },
      flightCode(flight) {
        if (flight === 'Nicklaus') {
            return 'Nick';
        }
        else if (flight === 'Palmer') {
            return 'Palm';
        }
        else {
            return 'Hogan';
        }
      },
      selectTournament(tn) {
        this.course=tn.course;
        this.tournament = tn.tournament;
        window.location.href = "/grouping?id=" + tn.tournament.tournamentId;
      },
      scoreCard(groupId) {
        console.log('SCORE CARD: ' + groupId);
        window.location.href = '/scoring?id=' + groupId;
      },
      getName(player) {
        if (player !==  null && player.firstName !== undefined) {
          return player.firstName + " " +
           (player.middleName!==null && player.middleName!==''?player.middleName.charAt(0):'')
            + " " + player.lastName;
        }
        return "";
      },
      getNames(players) {
        var name = "";
        for(var i=0; i < players.length; i++) {
            if (players[i] !==  null && players[i].firstName !== undefined) {
              name += players[i].firstName + " " +
               (players[i].middleName!==null && players[i].middleName!==''?players[i].middleName.charAt(0):'')
                + " " + players[i].lastName;
              name += "<br>";
            }
        }

        return name;
      },
      loadPlayers(tournament) {
        var _this = this;

        this.axios.get('/public/scores/score-card/group/' + tournament.tournamentId)
        .then(function (response) {
            var i;
            var players = response.data;

            _this.numberOfPlayers = 0;

            var size = 0;
            for(i=0; i < players.length; i++) {
              if (players[i].groupId > size) {
                size = players[i].groupId;
              }
            }

            _this.groups = new Array(size);

            for(i=0; i < size; i++) {
              _this.groups[i] = {
                groupId: i+1,
                aPlayers: new Array(),
                bPlayers: new Array()
              }
            }

            for(i=0; i < players.length; i++) {
              const gId = players[i].groupId;
              if (gId > 0) {
                _this.groups[gId-1].teeBox = players[i].teeBox;
                if (players[i].team === 'A') {
                    _this.groups[gId-1].aPlayers.push(players[i]);
                }
                else {
                    _this.groups[gId-1].bPlayers.push(players[i]);
                }
                _this.numberOfPlayers++
              }
            }
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      }
    }
  }

</script>

<style scoped>

    .group-card {
        width: 100%;
        float: left;
        margin: 10px 0;
    }

    .scoreCardBtn {
        font-size: 10px;
        font-weight: bold;
        float: right;
        background-color: #f2d3db !important;
        height: 26px !important;
        padding: 0 5px !important;
    }

    .groupPairingCard {
        margin-top: 20px;
        display: inline-block;
    }

    .scoreCardLabel {
        font-size: 12px;
        font-weight: bold;
        color: gold;
    }

    @media (min-width: 768px) {
        .group-card {
          margin: 10px;
        }

        .member-table {
            width: 100%;
        }

        td {
          font-size: 14px !important;
        }

        .group-card {
           width: 360px;
           height: 200px;
           vertical-align: top;
        }
    }

    th {
        text-align: left;
        height: 28px;
        background-color: #45472e;
        border:1px solid aquamarine;
        box-shadow:2px 2px 1px -1px #000;
        font-size: 16px;
        color: aquamarine;
    }

    th, td {
        padding: 2px 10px;
    }

    td {
        font-size: 14px;
        font-weight: bold;
        color: #2a2b1e;
        background-color: #dae6e6;
        border:1px solid rgba(0,0,0,0.4);
        box-shadow:-1px -1px 1px -1px #000;
    }

    .select-btn {
        margin-right: 20px;
        text-align: left;
        background-color: #1867c0;
        width:100%;
        border-radius: 7px;
        padding: 10px;
        color: white;
    }

    .select-btn:hover {
        cursor: pointer;
    }

</style>